export enum LobbyTabId {
    ALL_CATEGORIES,
    TOP_GAMES,
    LIVE_CASINO,
    SLOTS,
    GAME_SHOWS,
    INSTANTS,
    CUSTOM1,
    CUSTOM2,
    CUSTOM3,
    CUSTOM4,
    CUSTOM5,
}

export enum LobbyCategories {
    ALL_CATEGORIES = 'ALL_CATEGORIES',
    TOP_GAMES = 'TOP_GAMES',
    LIVE_CASINO = 'LIVE_CASINO',
    SLOTS = 'SLOTS',
    GAME_SHOWS = 'GAME_SHOWS',
    INSTANTS = 'INSTANTS',
    CUSTOM1 = 'CUSTOM1',
    CUSTOM2 = 'CUSTOM2',
    CUSTOM3 = 'CUSTOM3',
    CUSTOM4 = 'CUSTOM4',
    CUSTOM5 = 'CUSTOM5',
}
